import { FaLock } from "react-icons/fa";
import { TierLabel, Tier } from "@memento/types/subscription";
import { tierLabelToHuman } from "@memento/library/subscription";
import {
  Feature,
  getLowestTierSupporting,
} from "@memento/library/feature-access";
import { UpgradeLink } from "src/components/subscriptions/UpgradeLink";
import { Badge } from "src/components/Elements/Badge";
import { cn } from "src/utils/cn";

type LockedTierBadgeProps = {
  feature?: Feature;
  tier?: Tier;
};

const lockedTierBadgeVariants = {
  [TierLabel.BUSINESS]: `bg-blue-400`,
  [TierLabel.PLATINUM]: `bg-blue-900`,
  [TierLabel.PREMIUM]: `bg-blue-700`,
  [TierLabel.PLUS]: `bg-blue-500`,
  [TierLabel.PREFERRED]: `bg-blue-900`,
  [TierLabel.ADVANCED]: `bg-blue-700`,
  [TierLabel.EXTRA]: `bg-blue-500`,
  [TierLabel.NONE]: `bg-gray-500`,
};

// shows the lowest tier that supports a specific feature, or just a pill
// with the provided tier.
export const LockedTierBadge = ({ feature, tier }: LockedTierBadgeProps) => {
  if (!feature && !tier) {
    return null;
  }

  if (feature) {
    tier = getLowestTierSupporting(feature);
  }

  if (tier!.label === TierLabel.NONE) {
    return null;
  }

  return (
    <UpgradeLink feature={feature}>
      <Badge
        radius="full"
        className={cn(
          "px-4 py-2",
          tier?.label ? lockedTierBadgeVariants[tier.label] : `bg-gray-500`
        )}
      >
        <div className="flex flex-row items-center gap-x-1">
          <FaLock className="text-white" />
          <p>{tierLabelToHuman(tier!.label)}</p>
        </div>
      </Badge>
    </UpgradeLink>
  );
};
